
import { Button } from "../ui/button";
import { RefreshCcw } from "lucide-react";

interface NoResultsProps {
  onResetFilters: () => void;
}

export const NoResults = ({ onResetFilters }: NoResultsProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="rounded-full bg-muted p-3 mb-4">
        <RefreshCcw className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-xl font-semibold mb-2">Nessun articolo trovato con i filtri selezionati</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Non sono stati trovati articoli che corrispondono ai filtri selezionati. Prova a modificare i criteri di ricerca o a reimpostare i filtri.
      </p>
      <Button onClick={onResetFilters} variant="outline">
        Reimposta filtri
      </Button>
    </div>
  );
};
